import _ from 'lodash'
import { StyleSheet, SectionList, View } from 'react-native'
import HelperString from 'utils/helper-string'
import TextDivider from 'components/atoms/TextDivider'
import i18n from 'utils/i18n'
import ThemedBlock from 'components/atoms/ThemedBlock'
import React from 'react'
import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'
import { removeCartTimeslots } from 'services/redux/cart/actions'
import { useDispatch, useSelector } from 'react-redux'
import Timeslot from 'components/molecules/Timeslot'
import { selectCartEmployees } from 'services/redux/cart/reducers'
import TimeslotDivider from 'components/atoms/TimeslotDivider'
import HelperDate from 'utils/helper-date'

const BookingBlocks = ({ days }) => {
	
	const dispatch = useDispatch()
	
	const _cartEmployees = useSelector( selectCartEmployees );
	
	const onCancelItem = ( booking, callback ) => {
		const key = FetchTimeslotCapacity.keyByBooking( booking );
		
		dispatch( removeCartTimeslots( key ) )
		
		if( _.isFunction( callback ) ) {
			callback();
		}
	}
	
	const onRender = ({ item, section }) => {
		let optionNr = 0;
		return _.map( _cartEmployees, employee => {
			optionNr++;
			
			return (
				<>
					<RenderItem
						item={{
							...item,
							employee: employee
						}}
						section={ section }
						onCancel={ onCancelItem.bind( this ) }
					/>
					
					{ optionNr < _.size( _cartEmployees ) && (
						<TimeslotDivider />
					)}
				</>
			)
		})
	}
	
	return _.map( days, ( buildings, date ) => {
		if( _.size( buildings ) > 0 ) {
			return (
				<View
					key={ HelperString.hash( 'day-block', date ) }>
					
					<TextDivider text={ `${i18n.t('page.create.overview.bookings.title') } - ${ _.capitalize( HelperDate.date( date ).format('dddd - D MMMM') ) }`} />
					
					<ThemedBlock
						shadow>
						
						<SectionList
							sections={ buildings }
							renderItem={ onRender.bind( this ) }
							renderSectionFooter={ ({ section }) => {
								if( section.last === false ) {
									return <TimeslotDivider />;
								}
								
								return null;
							} }
							style={ staticStyles.sectionListOverflowVisibleMarginBottom10 }
						/>
					</ThemedBlock>
				</View>
			)
		}
	})
}

const RenderItem = ({ item, section, onCancel }) => {
	
	const itemStyle = {};
	if( section.last === true ) {
		itemStyle['borderBottomWidth'] = 0;
	}
	
	return (
		<Timeslot
			key={ HelperString.hash( `timeslot-view-calendar-${item.booking_date}`, FetchTimeslotCapacity.keyByBooking( item ) ) }
			item={ item }
			itemProps={{
				selected: true,
				selectableDisabled: true,
				showEmployeeElement: false,
				showEmployee: false,
				showCapacity: false,
				showLunchSelection: true,
				showLicensePlate: true
			}}
			itemStyle={ itemStyle }
		/>
	)
}

const staticStyles = StyleSheet.create({
	sectionListOverflowVisibleMarginBottom10: {
		overflow: 'visible',
		marginBottom: 10,
	},
});

export default BookingBlocks
